/* eslint-disable react/jsx-no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, Box, Button, Chip, CircularProgress, Divider, Grid, MenuItem, Modal, TextField, Typography } from '@mui/material';
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  checkUserAlreadyExist,
  deleteUserAdvertiser,
  onboardUserToDashboard,
  resetIAMFormData,
  sendIAMInvite
} from '../../redux/user/userActions';

import AnimateButton from 'ui-component/extended/AnimateButton';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { fetchAdvertiserList } from '../../redux/advertiser/advertiserActions';
import { gridSpacing } from 'store/constant';
import { set } from 'lodash';
import { useNavigate } from 'react-router-dom';

const AddUser = ({
  sendIAMInvite,
  onboardedIAMStatus,
  onboardedToDashboard,
  resetIAMFormData,
  iamUserList,
  checkUserAlreadyExist,
  userLoginForDashboardAlreadyExist,
  onboardUserToDashboard,
  deleteUserAdvertiser,
  showModal,
  closeModal,
  error,
  initialEmail = '',
  onSwitchToDashboardCustomization
}) => {
  //console.log(advertiserList)
  const [open, setOpen] = React.useState(showModal);
  const [loadingOB, setLoadingOB] = useState(false);
  const [loadingIAM, setLoading] = useState(false);
  const [value, setValue] = React.useState([]);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    sfid: '',
    advertiserName: '',
    advertiserGuid: '',
    timezone: '',
    platform: ''
  });
  const [userAdvertisers, setUserAdvertisers] = useState([]);
  const [loadingAdvertisers, setLoadingAdvertisers] = useState(false);
  const [emailTimeout, setEmailTimeout] = useState(null);
  const [advertiserMetaDetails, setAdvertiserMetaDetails] = useState([]);
  const [loadingMetaDetails, setLoadingMetaDetails] = useState(false);
  const [sfidOptions, setSfidOptions] = useState([]);
  const [advertiserNameOptions, setAdvertiserNameOptions] = useState([]);
  const [filteredAdvertisers, setFilteredAdvertisers] = useState([]);
  const [advertiserSearchTerm, setAdvertiserSearchTerm] = useState('');
  const [errors, setErrors] = useState({
    name: '',
    email: '',
    sfid: '',
    advertiserGuid: '',
    message: '',
    advertiserName: '',
    timezone: '',
    platform: ''
  });
  // const [selected_advertisers, setSelected_advertisers] = React.useState([]);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    closeModal(false);
    resetIAMFormData();
  };
  const navigate = useNavigate();
  useEffect(() => {
    console.log('checkUserAlreadyExistOnDashboard', userLoginForDashboardAlreadyExist);
    if (userLoginForDashboardAlreadyExist == true) {
      console.log('prev Error', errors.email);
      let prevError = errors.email;
      setErrors((prevErrors) => ({
        ...prevErrors,
        ['email']: prevError
      }));
    }
  }, [userLoginForDashboardAlreadyExist]);

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (emailTimeout) {
        clearTimeout(emailTimeout);
      }
    };
  }, [emailTimeout]);

  // Fetch advertiser meta details on component mount
  useEffect(() => {
    fetchAdvertiserMetaDetails();
  }, []);

  // Note: Removed auto-fill logic - SF ID and Advertiser Name should only be searchable, not auto-filled

  // Update SF ID and Advertiser Name options when userAdvertisers changes
  useEffect(() => {
    if (advertiserMetaDetails.length > 0) {
      const filteredMetaDetails = getFilteredAdvertiserMetaDetails();

      // Update SF ID options (only include SF IDs that have available advertisers)
      const availableSfids = [...new Set(filteredMetaDetails.map((item) => item.salesforce_account_id))];
      setSfidOptions(availableSfids);

      // Update advertiser name options (only include names from available advertisers)
      const availableAdvertiserNames = [...new Set(filteredMetaDetails.map((item) => item.advertiser_name))];
      setAdvertiserNameOptions(availableAdvertiserNames);
    }
  }, [userAdvertisers, advertiserMetaDetails]);
  // const renderTags = (value1, getTagProps) => {
  //   return (
  //     <>
  //       {value.map((option, index) => (
  //         <Chip {...getTagProps({ index })} key={index} label={option.name} onDelete={() => handleDelete(option)} />
  //       ))}
  //       {/* {value.length > 2 && (
  //             <span>
  //               {"+"}
  //               {value.length - 2} more
  //             </span>
  //           )} */}
  //     </>
  //   );
  // };
  const handleDelete = (deletedOption) => {
    //console.log(deletedOption,value)
    const newValue = value.filter((option) => option !== deletedOption);
    setValue(newValue);
  };

  const openAdvertiserList = () => {
    navigate('/advertisers', { replace: true });
    setOpen(false);
  };

  // Filter out advertisers that are already in Available Advertisers list
  const getFilteredAdvertiserMetaDetails = () => {
    if (userAdvertisers.length === 0) {
      return advertiserMetaDetails;
    }

    // Get GUIDs that are already in Available Advertisers
    const existingGuids = userAdvertisers.map((adv) => adv.advertiser_guid);

    // Filter out advertisers with existing GUIDs
    return advertiserMetaDetails.filter((adv) => !existingGuids.includes(adv.advertiser_guid));
  };

  // Fetch advertiser meta details on component mount
  const fetchAdvertiserMetaDetails = async () => {
    setLoadingMetaDetails(true);
    try {
      const response = await fetch('/get_advertiser_meta_details');
      if (response.ok) {
        const data = await response.json();
        if (data.data && Array.isArray(data.data)) {
          setAdvertiserMetaDetails(data.data);
          // Create unique SF ID options for autocomplete
          const uniqueSfids = [...new Set(data.data.map((item) => item.salesforce_account_id))];
          setSfidOptions(uniqueSfids);
          // Create unique advertiser name options for autocomplete
          const uniqueAdvertiserNames = [...new Set(data.data.map((item) => item.advertiser_name))];
          setAdvertiserNameOptions(uniqueAdvertiserNames);
        }
      }
    } catch (error) {
      console.error('Error fetching advertiser meta details:', error);
    } finally {
      setLoadingMetaDetails(false);
    }
  };

  // Fetch user advertiser details when email is entered
  const fetchUserAdvertiserDetails = async (email) => {
    if (!email || !validateEmail(email).isValid) {
      setUserAdvertisers([]);
      return;
    }

    setLoadingAdvertisers(true);
    try {
      const response = await fetch('/get_user_advertiser_details', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: email })
      });

      // Handle different response scenarios
      if (response.status === 404) {
        // User not found - this is a new user, show empty list
        console.log('New user detected:', email);
        setUserAdvertisers([]);
        setLoadingAdvertisers(false);
        return;
      }

      if (response.ok) {
        const data = await response.json();

        if (data.data && Array.isArray(data.data)) {
          // Only consider advertisers with selected="true"
          let selectedAdvertisers = data.data.filter((item) => item.selected === 'true');

          // If no selected=true items, this is a data issue - log warning
          if (selectedAdvertisers.length === 0) {
            console.warn('No advertisers with selected="true" found. This may indicate a backend data issue.');
          }

          // Deduplicate based on advertiser_guid (keep first occurrence)
          const uniqueSelectedAdvertisers = [];
          const seenGuids = new Set();

          for (const item of selectedAdvertisers) {
            if (!seenGuids.has(item.advertiser_guid)) {
              seenGuids.add(item.advertiser_guid);
              uniqueSelectedAdvertisers.push(item);
            }
          }

          setUserAdvertisers(uniqueSelectedAdvertisers);

          // Note: Removed auto-fill - user should manually select advertisers
        } else {
          setUserAdvertisers([]);
        }
      } else {
        setUserAdvertisers([]);
      }
    } catch (error) {
      console.error('Error fetching user advertiser details:', error);
      setUserAdvertisers([]);
    } finally {
      setLoadingAdvertisers(false);
    }
  };

  // Handle advertiser selection from the fetched list
  const handleAdvertiserSelect = (advertiser) => {
    const platform =
      advertiser.platform && advertiser.platform.length > 0 ? advertiser.platform[0] : '';
    const timezone = platform === 'CTV' || platform === 'GTV' ? 'UTC' : advertiser.timezone;
    setFormData((prev) => ({
      ...prev,
      advertiserName: advertiser.advertiser_name,
      advertiserGuid: advertiser.advertiser_guid,
      sfid: advertiser.salesforce_account_id,
      timezone,
      platform
    }));
  };

  // Handle SF ID selection and auto-fill advertiser details
  const handleSfidSelect = (selectedSfid) => {
    if (!selectedSfid) {
      setFormData((prev) => ({
        ...prev,
        sfid: '',
        advertiserGuid: '',
        advertiserName: ''
      }));
      setFilteredAdvertisers([]);
      return;
    }

    // Check if advertiserMetaDetails is loaded
    if (!advertiserMetaDetails || advertiserMetaDetails.length === 0) {
      console.warn('Advertiser meta details not loaded yet');
      // Set the SF ID but don't autofill other fields
      setFormData((prev) => ({
        ...prev,
        sfid: selectedSfid
      }));
      setFilteredAdvertisers([]);
      return;
    }

    // Find all advertisers with this SF ID (excluding already selected ones)
    const filteredMetaDetails = getFilteredAdvertiserMetaDetails();
    const matchingAdvertisers = filteredMetaDetails.filter((item) => item.salesforce_account_id === selectedSfid);

    console.log(`SF ID ${selectedSfid} found ${matchingAdvertisers.length} matching advertisers`);
    setFilteredAdvertisers(matchingAdvertisers);

    if (matchingAdvertisers.length > 0) {
      // Auto-fill with the first matching advertiser
      const advertiser = matchingAdvertisers[0];
      console.log('Auto-filling with advertiser:', advertiser.advertiser_name);
      const platform = advertiser.platform ? advertiser.platform[0] : '';
      const timezone =
        platform === 'CTV' || platform === 'GTV' ? 'UTC' : advertiser.timezone ? advertiser.timezone[0] : '';
      setFormData((prev) => ({
        ...prev,
        sfid: selectedSfid,
        advertiserGuid: advertiser.advertiser_guid,
        advertiserName: advertiser.advertiser_name,
        timezone,
        platform
      }));
    } else {
      console.warn(`No advertisers found for SF ID: ${selectedSfid}`);
      // Set the SF ID but clear other fields
      setFormData((prev) => ({
        ...prev,
        sfid: selectedSfid,
        advertiserGuid: '',
        advertiserName: ''
      }));
    }
  };

  // Handle advertiser name selection
  const handleAdvertiserNameSelect = (selectedName) => {
    if (!selectedName) {
      setFormData((prev) => ({
        ...prev,
        advertiserName: '',
        advertiserGuid: ''
      }));
      return;
    }

    // Find advertiser by name (prefer from filtered list if SF ID is selected)
    let matchingAdvertiser;

    // Check if selectedName contains GUID suffix (format: "Name (GUID)")
    const guidMatch = selectedName.match(/^(.+)\s\(([a-f0-9]{8})\)$/);
    const cleanName = guidMatch ? guidMatch[1] : selectedName;
    const guidSuffix = guidMatch ? guidMatch[2] : null;

    if (filteredAdvertisers.length > 0) {
      // If SF ID is selected, only search within filtered advertisers
      if (guidSuffix) {
        // If GUID suffix is present, find by both name and GUID
        matchingAdvertiser = filteredAdvertisers.find(
          (item) => item.advertiser_name === cleanName && item.advertiser_guid.startsWith(guidSuffix)
        );
      } else {
        // If no GUID suffix, find by name only
        matchingAdvertiser = filteredAdvertisers.find((item) => item.advertiser_name === selectedName);
      }
    } else {
      // If no SF ID selected, search in filtered advertisers (excluding already selected ones)
      const filteredMetaDetails = getFilteredAdvertiserMetaDetails();
      if (guidSuffix) {
        // If GUID suffix is present, find by both name and GUID
        matchingAdvertiser = filteredMetaDetails.find(
          (item) => item.advertiser_name === cleanName && item.advertiser_guid.startsWith(guidSuffix)
        );
      } else {
        // If no GUID suffix, find by name only
        matchingAdvertiser = filteredMetaDetails.find((item) => item.advertiser_name === selectedName);
      }
    }

    if (matchingAdvertiser) {
      const platform = matchingAdvertiser.platform ? matchingAdvertiser.platform[0] : '';
      const timezone =
        platform === 'CTV' || platform === 'GTV'
          ? 'UTC'
          : matchingAdvertiser.timezone
            ? matchingAdvertiser.timezone[0]
            : '';
      setFormData((prev) => ({
        ...prev,
        advertiserName: cleanName, // Store clean name without GUID suffix
        advertiserGuid: matchingAdvertiser.advertiser_guid,
        // Auto-fill SF ID if not already set
        ...(prev.sfid ? {} : { sfid: matchingAdvertiser.salesforce_account_id }),
        timezone,
        platform
      }));
    } else {
      // If no matching advertiser found, just update the name
      setFormData((prev) => ({
        ...prev,
        advertiserName: selectedName,
        advertiserGuid: ''
      }));
    }
  };

  const validateEmail = (email) => {
    // First check if it's a valid email format
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!re.test(String(email).toLowerCase())) {
      return { isValid: false, message: 'Invalid email address' };
    }

    // Then check if it's an inmobi.com email
    if (email.toLowerCase().endsWith('@inmobi.com')) {
      return { isValid: false, message: 'Enter valid email id' };
    }

    return { isValid: true, message: '' };
  };

  // Check user already IAM onboarded or not
  const checkEmailExist = (email) => {
    // console.log(email);
    // console.log(iamUserList)
    const emailExist = iamUserList.some((iamUser) => iamUser.email === email);
    // console.log(emailExist)
    return emailExist;
  };
  //Check whether user is already onboarded to Dashboard Backend
  const checkUserAlreadyExistOnDashboard = (email) => {
    let status;
    if (email != '') {
      status = checkUserAlreadyExist(email);
    }
    return status;
  };
  const validateField = (name, value) => {
    let error = '';
    if (name === 'dropdown' && value.length === 0) {
      console.log('inside this');
      error = 'At least one option must be selected';
      //isValid = false;
    } else if (name === 'name' && value.trim() === '') {
      error = `${name.charAt(0).toUpperCase() + name.slice(1)} is required`;
    } else if (name === 'advertiserGuid' && value.trim() === '') {
      error = `Advertiser Guid is required`;
    } else if (name === 'advertiserName' && value.trim() === '') {
      error = `Advertiser Name is required`;
    } else if (name === 'email') {
      const emailValidation = validateEmail(value);
      if (!emailValidation.isValid) {
        error = emailValidation.message;
      } else if (checkEmailExist(value)) {
        error = 'Email Already Exist ON IAM';
      }
    } else if (name === 'sfid' && value.trim() === '') {
      error = `SF Id is required`;
    } else if ((name === 'timezone' || name === 'platform') && !value) {
      error = `${name} is required`;
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error
    }));
    // if (name === 'email' && validateEmail(value) == true) {
    //   console.log('valid email');
    //   let userExist = checkUserAlreadyExistOnDashboard(value);
    //   console.log(userExist);
    // }
  };
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: value
  //   });
  //   validateField(name, value);
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'platform') {
      const next = { platform: value };
      if (value === 'CTV' || value === 'GTV') {
        next.timezone = 'UTC';
      }
      setFormData((prev) => ({
        ...prev,
        ...next
      }));
      validateField('platform', value);
      if (value === 'CTV' || value === 'GTV') {
        validateField('timezone', 'UTC');
      } else {
        validateField('timezone', formData.timezone);
      }
    } else if (name === 'timezone') {
      setFormData((prev) => {
        const tz = prev.platform === 'CTV' || prev.platform === 'GTV' ? 'UTC' : value;
        return { ...prev, timezone: tz };
      });
      const effectiveTz = formData.platform === 'CTV' || formData.platform === 'GTV' ? 'UTC' : value;
      validateField('timezone', effectiveTz);
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value
      }));
      validateField(name, value);
    }

    // If email field is changed, fetch user advertiser details with debounce
    if (name === 'email') {
      // Clear existing timeout
      if (emailTimeout) {
        clearTimeout(emailTimeout);
      }

      // Set new timeout to debounce API calls
      const newTimeout = setTimeout(() => {
        fetchUserAdvertiserDetails(value);
      }, 500); // 500ms delay

      setEmailTimeout(newTimeout);
    }
  };
  // const handleAutocompleteChange = (event, value) => {
  //   setValue(value);
  //   const selectedIds = value.map((item) => item.id);
  //   setSelected_advertisers(selectedIds);
  //   validateField('dropdown', selectedIds);
  // };
  const handleOnboardUserToDashboard = async () => {
    // Validate email before proceeding
    const emailValidation = validateEmail(formData.email);
    if (!emailValidation.isValid) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        ['email']: emailValidation.message
      }));
      return;
    }
    if (formData.advertiserName == '') {
      setErrors((prevErrors) => ({
        ...prevErrors,
        ['advertiserName']: 'Advertiser name is required'
      }));
      return;
    }

    // Check if this is an update to existing user or new user creation
    const isExistingUser = userLoginForDashboardAlreadyExist;
    const operation = isExistingUser ? 'update' : 'create';

    console.log(`${operation === 'update' ? 'Updating' : 'Creating'} user with email:`, formData.email);
    setLoadingOB(true);

    try {
      // Step 1: First call DELETE API to remove existing advertiser details
      console.log('Step 1: Calling deleteAdvertiserDetails...');
      const deleteData = {
        email_id: formData.email,
        role: 'client',
        advertisers: [
          {
            id: formData.advertiserGuid
          }
        ]
      };

      // Call delete API first
      await new Promise((resolve, reject) => {
        deleteUserAdvertiser(deleteData);
        // Give it a moment to complete
        setTimeout(resolve, 1000);
      });

      // Step 2: Then call ONBOARD API to add/update user and advertiser details
      console.log('Step 2: Calling onboardUserAndAdvertiserDetails...');
      const effectiveTimezone = formData.platform === 'CTV' || formData.platform === 'GTV' ? 'UTC' : formData.timezone;
      const onboardData = {
        email_id: formData.email,
        role: 'client',
        advertisers: [
          {
            id: formData.advertiserGuid,
            name: formData.advertiserName,
            sfId: formData.sfid,
            timezone: effectiveTimezone,
            platform: formData.platform
          }
        ]
      };
      onboardUserToDashboard(onboardData);
    } catch (error) {
      console.error('Error in onboard process:', error);
    } finally {
      setTimeout(() => {
        setLoadingOB(false);
      }, 4000);
    }
  };
  const handleIAMInviteSend = () => {
    console.log('iam invite');
    // Validate email before proceeding
    const emailValidation = validateEmail(formData.email);
    if (!emailValidation.isValid) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        ['email']: emailValidation.message
      }));
      return;
    }

    if (formData.name != '' && formData.email != '') {
      setLoading(true);
      sendIAMInvite(formData);
    }
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };
  return (
    <>
      <Grid container spacing={gridSpacing}>
        <Grid item lg={2} md={10} sm={8} xs={6}></Grid>
        <Grid item lg={8} md={4} sm={4} xs={6}>
          {/* <SearchBar/> */}
          {/* <AnimateButton>
            <Button
              disableElevation
              disabled={false}
              fullWidth
              size="large"
              type="submit"
              variant="outlined"
              color="secondary"
              onClick={handleOpen}
            >
              Add User
            </Button>
          </AnimateButton> */}
          {/* <Modal open={open} onClose={handleClose}>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '100%',
                maxWidth: 500,
                maxHeight: '90vh',
                overflowY: 'auto',
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 3,
                borderRadius: 2
              }}
            > */}
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Box
                sx={{
                  textAlign: 'center',
                  mb: 3,
                  p: 2,
                  backgroundColor: '#aad8f9ff',
                  borderRadius: 2,

                  border: '1px solid #5db8f8ff' // soft border
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 'bold',
                    mb: 1,
                    color: 'black'
                  }}
                >
                  Client Details
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontStyle: 'italic',
                    color: 'black'
                  }}
                >
                  Onboard new client to the dashboard
                </Typography>
              </Box>
            </Grid>

            {/* Left Column - Form Fields */}
            <Grid item xs={12} lg={7}>
              <Box
                sx={{
                  p: 3,
                  border: '1px solid #e0e0e0',
                  borderRight: {
                    xs: '1px solid #e0e0e0',
                    lg: '3px solid #1976d2'
                  },
                  borderRadius: 2,
                  backgroundColor: 'white',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    mb: 2,
                    fontWeight: 'bold',
                    color: '#1976d2',
                    borderBottom: '2px solid #1976d2',
                    pb: 1
                  }}
                >
                  Client and Advertiser Details
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      autoFocus
                      fullWidth
                      name="name"
                      label="Enter First Name & Last Name"
                      value={formData.name}
                      onChange={handleChange}
                      error={!!errors.name}
                      helperText={errors.name}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      name="email"
                      label="Email Address"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      error={!!errors.email}
                      helperText={errors.email}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Autocomplete
                      fullWidth
                      options={sfidOptions}
                      value={formData.sfid}
                      onChange={(event, newValue) => {
                        setFormData((prev) => ({
                          ...prev,
                          sfid: newValue || ''
                        }));
                        handleSfidSelect(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="SF ID (Salesforce Account ID)"
                          error={!!errors.sfid}
                          helperText={
                            errors.sfid ||
                            (userAdvertisers.length > 0
                              ? `Search and select SF ID. ${userAdvertisers.length} advertiser(s) already selected.`
                              : 'Search and select SF ID to autofill other fields')
                          }
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loadingMetaDetails ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            )
                          }}
                        />
                      )}
                      disableClearable={false}
                    />
                    {filteredAdvertisers.length > 1 && (
                      <Box
                        sx={{
                          mt: 1,
                          p: 1,
                          backgroundColor: '#e3f2fd',
                          border: '1px solid #bbdefb',
                          borderRadius: 1
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            color: '#1976d2',
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5
                          }}
                        >
                          ℹ️ This SF ID has {filteredAdvertisers.length} advertisers. Please select the specific advertiser name below.
                        </Typography>
                      </Box>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <Autocomplete
                      fullWidth
                      options={(() => {
                        const options =
                          filteredAdvertisers.length > 0
                            ? filteredAdvertisers.map((adv, index) => {
                                // If there are multiple advertisers with the same name, add GUID suffix
                                const duplicateNames = filteredAdvertisers.filter((a) => a.advertiser_name === adv.advertiser_name);
                                if (duplicateNames.length > 1) {
                                  return `${adv.advertiser_name} (${adv.advertiser_guid.substring(0, 8)})`;
                                }
                                return adv.advertiser_name;
                              })
                            : advertiserNameOptions;

                        return options;
                      })()}
                      value={formData.advertiserName}
                      onChange={(event, newValue) => {
                        handleAdvertiserNameSelect(newValue);
                      }}
                      onInputChange={(event, newInputValue) => {
                        // Only update if it's a manual input (not from selection)
                        if (newInputValue !== formData.advertiserName) {
                          setFormData((prev) => ({
                            ...prev,
                            advertiserName: newInputValue
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Advertiser Name"
                          error={!!errors.advertiserName}
                          helperText={
                            errors.advertiserName ||
                            (filteredAdvertisers.length > 0
                              ? `Showing ${filteredAdvertisers.length} advertiser(s) for selected SF ID`
                              : userAdvertisers.length > 0
                              ? `Search and select advertiser name. ${userAdvertisers.length} advertiser(s) already selected.`
                              : 'Search and select advertiser name. This name will be visible to the advertiser.')
                          }
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loadingMetaDetails ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            )
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          {...props}
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            py: 1,
                            '&:hover': {
                              backgroundColor: '#f5f5f5'
                            }
                          }}
                        >
                          <Box
                            sx={{
                              width: 8,
                              height: 8,
                              borderRadius: '50%',
                              backgroundColor: '#1976d2',
                              mr: 1.5,
                              flexShrink: 0
                            }}
                          />
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 'medium',
                              color: '#333'
                            }}
                          >
                            {option}
                          </Typography>
                        </Box>
                      )}
                      ListboxProps={{
                        sx: {
                          maxHeight: 300,
                          '& .MuiAutocomplete-option': {
                            padding: '8px 16px'
                          }
                        }
                      }}
                      freeSolo
                      disableClearable={false}
                      noOptionsText="No advertisers found"
                      loading={loadingMetaDetails}
                      loadingText="Loading advertisers..."
                    />
                    {formData.advertiserName && (
                      <Box
                        sx={{
                          mt: 1,
                          p: 1,
                          backgroundColor: '#f8f9fa',
                          border: '1px solid #e9ecef',
                          borderRadius: 1
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            color: '#6c757d',
                            fontWeight: 'medium',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5
                          }}
                        >
                          📝 Note: This advertiser name will be visible to the Advertiser. You can edit it if you wish to. Currently, this
                          is coming from the system.
                        </Typography>
                      </Box>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      name="advertiserGuid"
                      label="Advertiser GUID"
                      value={formData.advertiserGuid}
                      onChange={handleChange}
                      error={!!errors.advertiserGuid}
                      helperText={errors.advertiserGuid || 'Auto-filled based on selected SF ID'}
                      InputProps={{
                        readOnly: true,
                        style: { backgroundColor: '#f5f5f5' }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      select
                      fullWidth
                      name="timezone"
                      label="Select Timezone"
                      value={formData.platform === 'CTV' || formData.platform === 'GTV' ? 'UTC' : formData.timezone}
                      onChange={handleChange}
                      error={!!errors.timezone}
                      helperText={
                        formData.platform === 'CTV'
                          ? 'CTV uses UTC only'
                          : formData.platform === 'GTV'
                          ? 'GTV uses UTC only'
                          : errors.timezone
                      }
                      disabled={formData.platform === 'CTV' || formData.platform === 'GTV'}
                    >
                      <MenuItem value="UTC">UTC</MenuItem>
                      {formData.platform !== 'CTV' && formData.platform !== 'GTV' && <MenuItem value="JST">JST</MenuItem>}
                    </TextField>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      select
                      fullWidth
                      name="platform"
                      label="Select Platform"
                      value={formData.platform}
                      onChange={handleChange}
                      error={!!errors.platform}
                      helperText={errors.platform}
                    >
                      <MenuItem value="DSP">DSP</MenuItem>
                      <MenuItem value="IAP Offline">IAP Offline</MenuItem>
                      <MenuItem value="CTV">CTV</MenuItem>
                      <MenuItem value="GTV">GTV</MenuItem>
                    </TextField>
                  </Grid>

                  <Grid item xs={12}>
                    {userLoginForDashboardAlreadyExist && (
                      <Box
                        sx={{
                          mb: 2,
                          p: 2,
                          backgroundColor: '#fff3cd',
                          border: '1px solid #ffeaa7',
                          borderRadius: 1
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#856404',
                            fontWeight: 'medium',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5
                          }}
                        >
                          This email already exists in the system. Clicking &quot;Update User&quot; will update the advertiser details for
                          this existing user.
                        </Typography>
                      </Box>
                    )}
                    {/* New button styles - single line */}
                    {(() => {
                      const buttonStyles = {
                        width: '9em',
                        height: '3em',
                        borderRadius: '30em',
                        fontSize: '15px',
                        fontFamily: 'inherit',
                        border: 'none',
                        position: 'relative',
                        overflow: 'hidden',
                        zIndex: 1,
                        boxShadow: '6px 6px 12pxrgb(255, 255, 255), -6px -6px 12px #ffffff',
                        background: '#e8e8e8',
                        cursor: 'pointer',
                        textTransform: 'none',
                        fontWeight: 500,
                        color: '#090909',
                        '&::before': {
                          content: '""',
                          width: 0,
                          height: '3em',
                          borderRadius: '30em',
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          backgroundImage: 'linear-gradient(to right,rgb(15, 203, 216) 0%,rgb(71, 154, 249) 100%)',
                          transition: '.5s ease',
                          display: 'block',
                          zIndex: -1
                        },
                        '&:hover::before': {
                          width: '9em'
                        },
                        '&:disabled': {
                          opacity: 0.6,
                          cursor: 'not-allowed'
                        }
                      };

                      const statusIconStyles = {
                        color: '#22ae2d',
                        fontSize: 18
                      };

                      const errorIconStyles = {
                        color: '#e53935',
                        fontSize: 18
                      };

                      return (
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 2,
                            mt: 3,
                            flexWrap: 'wrap'
                          }}
                        >
                          <Button
                            onClick={() => {
                              openAdvertiserList();
                            }}
                            variant="text"
                            sx={buttonStyles}
                          >
                            Cancel
                          </Button>

                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.5
                            }}
                          >
                            <Button onClick={handleOnboardUserToDashboard} variant="text" disabled={loadingOB} sx={buttonStyles}>
                              {loadingOB ? (
                                <CircularProgress size={16} color="inherit" />
                              ) : userLoginForDashboardAlreadyExist ? (
                                'Update User'
                              ) : (
                                'Onboard User'
                              )}
                            </Button>
                            {onboardedToDashboard && <CheckCircleIcon sx={statusIconStyles} />}
                            {error === 'User Onboarding Failed' && !onboardedToDashboard && <CancelIcon sx={errorIconStyles} />}
                          </Box>

                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.5
                            }}
                          >
                            <Button onClick={handleIAMInviteSend} variant="text" disabled={loadingIAM} sx={buttonStyles}>
                              {loadingIAM ? <CircularProgress size={16} color="inherit" /> : 'Send IAM Invite'}
                            </Button>
                            {onboardedIAMStatus && <CheckCircleIcon sx={statusIconStyles} />}
                            {error === 'Unable To Onboard IAM' && !onboardedIAMStatus && <CancelIcon sx={errorIconStyles} />}
                          </Box>
                        </Box>
                      );
                    })()}
                  </Grid>

                  {errors.message && (
                    <Grid item xs={12}>
                      <Typography color="error">{errors.message}</Typography>
                    </Grid>
                  )}

                  {onboardedToDashboard && (
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          p: 2,
                          backgroundColor: '#f0f9ff',
                          border: '1px solid #0ea5e9',
                          borderRadius: '8px',
                          textAlign: 'center'
                        }}
                      >
                        <Typography color="primary" sx={{ fontWeight: 600, mb: 1 }}>
                          ✅ User onboarded successfully!
                        </Typography>
                        <Typography color="textSecondary" sx={{ fontSize: '0.9rem', mb: 2 }}>
                          We suggest you to customize the dashboard for the user. Otherwise default view will be visible for the user.
                        </Typography>
                        {onSwitchToDashboardCustomization && (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              console.log('🔍 Debug - Button clicked with email:', formData.email);
                              onSwitchToDashboardCustomization(formData.email);
                            }}
                            sx={{
                              borderRadius: '8px',
                              textTransform: 'none',
                              fontWeight: 600,
                              px: 3,
                              py: 1
                            }}
                          >
                            Customize Dashboard
                          </Button>
                        )}
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Grid>

            {/* Right Column - Available Advertisers */}
            <Grid item xs={12} lg={5}>
              <Box
                sx={{
                  position: { xs: 'static', lg: 'sticky' },
                  top: 20,
                  p: 3,
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  backgroundColor: 'white',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  minHeight: { xs: 'auto', lg: 400 },
                  mt: { xs: 2, lg: 0 }
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: 2,
                    borderBottom: '2px solid #2e7d32',
                    pb: 1
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 'bold',
                      color: '#2e7d32'
                    }}
                  >
                    Available Advertisers
                  </Typography>
                  <TextField
                    size="small"
                    placeholder="Search..."
                    value={advertiserSearchTerm}
                    onChange={(e) => setAdvertiserSearchTerm(e.target.value)}
                    sx={{
                      width: 120,
                      '& .MuiOutlinedInput-root': {
                        fontSize: '0.75rem',
                        height: 28
                      },
                      '& .MuiInputBase-input': {
                        padding: '4px 8px'
                      }
                    }}
                    InputProps={{
                      startAdornment: (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            mr: 0.5,
                            color: '#666'
                          }}
                        >
                          🔍
                        </Box>
                      )
                    }}
                  />
                </Box>

                {loadingAdvertisers && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      mb: 2
                    }}
                  >
                    <CircularProgress size={20} />
                    <Typography variant="body2" color="textSecondary">
                      Loading advertiser details...
                    </Typography>
                  </Box>
                )}

                {userAdvertisers.length > 0 && !loadingAdvertisers && (
                  <Box sx={{ maxHeight: 350, overflowY: 'auto' }}>
                    {userAdvertisers
                      .filter(
                        (advertiser) =>
                          advertiserSearchTerm === '' ||
                          advertiser.advertiser_name.toLowerCase().includes(advertiserSearchTerm.toLowerCase()) ||
                          advertiser.advertiser_guid.toLowerCase().includes(advertiserSearchTerm.toLowerCase()) ||
                          advertiser.salesforce_account_id.toLowerCase().includes(advertiserSearchTerm.toLowerCase()) ||
                          advertiser.timezone.toLowerCase().includes(advertiserSearchTerm.toLowerCase()) ||
                          (advertiser.platform &&
                            advertiser.platform.some((p) => p.toLowerCase().includes(advertiserSearchTerm.toLowerCase())))
                      )
                      .map((advertiser, index) => (
                        <Box
                          key={index}
                          sx={{
                            p: 2,
                            mb: 1.5,
                            border: '1px solid #e0e0e0',
                            borderRadius: 1,
                            cursor: 'pointer',
                            backgroundColor: 'white',
                            '&:hover': {
                              backgroundColor: '#f8f9fa',
                              borderColor: '#1976d2',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                            }
                          }}
                          onClick={() => handleAdvertiserSelect(advertiser)}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 'bold',
                              mb: 1,
                              color: '#1976d2',
                              fontSize: '0.95rem'
                            }}
                          >
                            {advertiser.advertiser_name}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{
                              display: 'block',
                              mb: 0.5,
                              fontSize: '0.8rem'
                            }}
                          >
                            GUID: {advertiser.advertiser_guid}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{
                              display: 'block',
                              fontSize: '0.8rem'
                            }}
                          >
                            SF ID: {advertiser.salesforce_account_id} | Timezone: {advertiser.timezone} | Platform:{' '}
                            {advertiser.platform && advertiser.platform.join(', ')}
                          </Typography>
                        </Box>
                      ))}
                  </Box>
                )}

                {userAdvertisers.length > 0 &&
                  !loadingAdvertisers &&
                  advertiserSearchTerm &&
                  userAdvertisers.filter(
                    (advertiser) =>
                      advertiserSearchTerm === '' ||
                      advertiser.advertiser_name.toLowerCase().includes(advertiserSearchTerm.toLowerCase()) ||
                      advertiser.advertiser_guid.toLowerCase().includes(advertiserSearchTerm.toLowerCase()) ||
                      advertiser.salesforce_account_id.toLowerCase().includes(advertiserSearchTerm.toLowerCase()) ||
                      advertiser.timezone.toLowerCase().includes(advertiserSearchTerm.toLowerCase()) ||
                      (advertiser.platform && advertiser.platform.some((p) => p.toLowerCase().includes(advertiserSearchTerm.toLowerCase())))
                  ).length === 0 && (
                    <Box sx={{ textAlign: 'center', py: 3 }}>
                      <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic' }}>
                        No advertisers match your search.
                      </Typography>
                    </Box>
                  )}

                {userAdvertisers.length === 0 && !loadingAdvertisers && formData.email && validateEmail(formData.email).isValid && (
                  <Box sx={{ textAlign: 'center', py: 4 }}>
                    <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic' }}>
                      No advertisers found for this email address. This appears to be a new user. You can proceed to add advertiser details
                      manually using the form fields.
                    </Typography>
                  </Box>
                )}

                {!formData.email && (
                  <Box sx={{ textAlign: 'center', py: 4 }}>
                    <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic' }}>
                      Enter an email address to see available advertisers.
                    </Typography>
                  </Box>
                )}

                {userAdvertisers.length > 0 && (
                  <Typography variant="caption" color="textSecondary" sx={{ mt: 2, display: 'block', textAlign: 'center' }}>
                    Click on an advertiser to auto-fill the form
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
          {/* </Box>
          </Modal> */}
        </Grid>
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.advertiserReducer.loading,
    error: state.advertiserReducer.error,
    advertiserList: state.advertiserReducer.advertiser_list,
    onboardedIAMStatus: state.userReducer.onboardedIAM,
    onboardedToDashboard: state.userReducer.onboardedToDashboard,
    iamUserList: state.userReducer.iamUserList,
    userLoginForDashboardAlreadyExist: state.userReducer.userLoginForDashboardAlreadyExist
  };
};
const mapDispatchToProps = {
  fetchAdvertiserList: fetchAdvertiserList,
  sendIAMInvite: sendIAMInvite,
  resetIAMFormData: resetIAMFormData,
  checkUserAlreadyExist: checkUserAlreadyExist,
  onboardUserToDashboard: onboardUserToDashboard,
  deleteUserAdvertiser: deleteUserAdvertiser
};
export default connect(mapStateToProps, mapDispatchToProps)(AddUser);
